export const LISTE_TYPE_TAXATION_TLPE = {
  title: 'Liste des types de taxation TLPE',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste type taxation TLPE',
  },
  actions: {
    add: 'Ajouter un type de taxation TLPE',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
    dupliquer: 'Dupliquer une valeur pour',
    create: 'Créer une valeur pour',
  },
  tab: {
    libelle: 'Libellé',
    actif: 'Actif',
  },
  childrow: {
    anneeCivile: 'Année civile',
    montantAnnuel: 'Montant annuel / m2',
    montantSemaine: 'Montant semaine / m2',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver ce type de taxation tlpe ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver ce type de taxation tlpe ?',
  },
  messages: {
    success: {
      archivage: 'Type de taxation tlpe archivé avec succès.',
      desarchivage: 'Type de taxation tlpe désarchivé avec succès.',
      suppression: 'Le type de taxation TLPE a été supprimé avec succès',
    },
  },
  filtres: {
    actif: {
      tilte: 'Actif',
      yes: 'Oui',
      no: 'Non',
    },
  },
  suppression: {
    confirmation: 'Êtes-vous sûr de vouloir supprimer ce type de taxation tlpe ?',
  },

};

export const ADD_TYPE_TAXATION_TLPE = {
  titleAdd: 'Ajouter un type de taxation TLPE',
  titleEdit: 'Modifier type de taxation TLPE {libelle}',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste type réseau',
  },
  actions: {
    addLigne: 'Ajouter une année civile',
    back: 'Retour',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
    anneeCivileAleradyExist: 'L\'année civile existe déjà dans ce type de taxation TLPE',
    anneeCivile: 'Année civile',
    montantSemaine: 'Montant semaine / m2',
    montantAnnuel: 'Montant annuel / m2',
  },
  success: {
    add: 'Le type de taxation TLPE a été ajouté avec succès.',
    edit: 'Le type de taxation TLPE a été modifié avec succès.',
    createMultiTypeTaxationTlpeLigne: 'L\'année civile a été ajoutée aux types de taxation sélectionnés avec succès.',
    dupliquer: 'L\'année civile sélectionée a été dupliquée aux types de taxation sélectionnés avec succès.',
  },
  informationTypeTaxationTlpe: {
    libelle: 'Libellé',
    typeTaxationTlpeLignes: {
      anneeCivile: 'Année civile',
      montantSemaine: 'Montant semaine / m2',
      montantAnnuel: 'Montant annuel / m2',
    },
  },
  popUpCreate: {
    title: 'Créer une valeur pour',
    anneeCivile: 'Année civile',
    montantAnnuel: 'Montant annuel / m2',
    montantSemaine: 'Montant semaine / m2',
    actions: {
      cancel: 'Annuler',
    },
  },
  popUpDuplicate: {
    title: 'Dupliquer une valeur pour',
    anneeACopier: 'Année à copier',
    anneeACreer: 'Année à créer',
    actions: {
      cancel: 'Annuler',
    },
  },
};
